import React from 'react';

import moment from 'moment';

// Helper function to check if a string is a valid URL
const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

export const baseoptions = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? row.expectedOutcome.toFixed(2) : '-'}</div> }
  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2 ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const addColumnsBasedOnSection = (sectionTitle, recommendationType) => {
  // let options = { ...baseOptions, columns: [...baseOptions.columns] }; uncomment while coding

  switch (sectionTitle) {
    case 'generativeAI':
      if (['creative', 'keyword'].includes(recommendationType)) {
        options.columns.push(
          { id: 6, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' }
        );
      }
      break;
    case 'blackListing':
      switch (recommendationType) {
        case 'creative':
          options.columns.push(
            { id: 6, name: 'creativeName', label: 'CREATIVE NAME', sortable: true, type: 'string' },
            { id: 7, name: 'creativeId', label: 'CREATIVE ID', sortable: true, type: 'number' }
          );
          break;
        case 'domain':
          options.columns.push(
            { id: 6, name: 'domain', label: 'DOMAIN', sortable: true, type: 'string' }
          );
          break;
        case 'keyword':
          options.columns.push(
            { id: 6, name: 'keywordName', label: 'KEYWORD NAME', sortable: true, type: 'string' },
            { id: 7, name: 'keywordType', label: 'KEYWORD TYPE', sortable: true, type: 'string' }
          );
          break;
        case 'age':
          options.columns.push(
            { id: 6, name: 'age', label: 'AGE', sortable: true, type: 'string' }
          );
          break;
        case 'gender':
          options.columns.push(
            { id: 6, name: 'gender', label: 'GENDER', sortable: true, type: 'string' }
          );
          break;
        case 'placements':
          options.columns.push(
            { id: 6, name: 'placement', label: 'PLACEMENT', sortable: true, type: 'string' }
          );
          break;
        case 'geo':
          options.columns.push(
            { id: 6, name: 'country', label: 'COUNTRY', sortable: true, type: 'string', component: (row) => <div>{row && row.country ? row.country : '-'}</div> },
            { id: 7, name: 'state', label: 'STATE', sortable: true, type: 'string', component: (row) => <div>{row && row.state ? row.state : '-'}</div> },
            { id: 8, name: 'city', label: 'CITY', sortable: true, type: 'string', component: (row) => <div>{row && row.city ? row.city : '-'}</div> }
          );
          break;
        case 'device':
          options.columns.push(
            { id: 6, name: 'device', label: 'DEVICE NAME', sortable: true, type: 'string' }
          );
          break;
        default:
          break;
      }
      break;
    case 'budgetOptimisation':
      switch (recommendationType) {
        case 'budget':
          options.columns.push(
            { id: 6, name: 'oldBudget', label: 'OLD BUDGET', sortable: true, type: 'string' },
            { id: 7, name: 'newBudget', label: 'NEW BUDGET', sortable: true, type: 'number' },
            { id: 8, name: 'currency', label: 'CURRENCY', sortable: true, type: 'string' }
          );
          break;
        case 'targetCpc':
          options.columns.push(
            { id: 6, name: 'currentCpc', label: 'Current CPC', sortable: true, type: 'number' },
            { id: 7, name: 'targetCpc', label: 'Target CPC', sortable: true, type: 'number' }
          );
          break;
        case 'targetCpm':
          options.columns.push(
            { id: 6, name: 'currentCpm', label: 'Current CPM', sortable: true, type: 'number' },
            { id: 7, name: 'targetCpm', label: 'Target CPM', sortable: true, type: 'number' }
          );
          break;
        case 'targetCpa':
          options.columns.push(
            { id: 6, name: 'currentCpa', label: 'Current CPA', sortable: true, type: 'number' },
            { id: 7, name: 'targetCpa', label: 'Target CPA', sortable: true, type: 'number' }
          );
          break;
        default:
          break;
      }
      break;
    case 'bidControl':
      switch (recommendationType) {
        case 'age':
          options.columns.push(
            { id: 6, name: 'age', label: 'AGE', sortable: true, type: 'string' },
            { id: 7, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' }
          );
          break;
        case 'gender':
          options.columns.push(
            { id: 6, name: 'gender', label: 'GENDER', sortable: true, type: 'string' },
            { id: 7, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' }
          );
          break;
        case 'audience':
          options.columns.push(
            { id: 6, name: 'audience', label: 'AUDIENCE', sortable: true, type: 'string' },
            { id: 7, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' }
          );
          break;
        case 'geo':
          options.columns.push(
            { id: 6, name: 'geo', label: 'GEO', sortable: true, type: 'string' },
            { id: 7, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' }
          );
          break;
        case 'device':
          options.columns.push(
            { id: 6, name: 'device', label: 'DEVICE NAME', sortable: true, type: 'string' },
            { id: 7, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' }
          );
          break;
        default:
          break;
      }
      break;
    default:
      break;
  }

  return options;
};


const getPlatformSpecificId = (platformName, row) => {
  switch (platformName) {
    case 'Meta':
      return { key: 'adSetId', label: 'ADSET ID', value: row.adSetId };
    case 'Google Ads':
      return { key: 'adGroupId', label: 'ADGROUP ID', value: row.adGroupId };
    case 'DV360':
      return { key: 'lineItemId', label: 'LINEITEM ID', value: row.lineItemId };
    default:
      return { key: 'adSetId', label: 'ADSET / STRATEGY ID', value: row.adSetId };
  }
}

//GENAI

export const options = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    // { id: 5, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 5, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string', component: (row) => row && row.recommendation && isValidUrl(row.recommendation) ? <a href={row.recommendation} target="_blank" rel="noopener noreferrer" style={{ display: 'block', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.recommendation}</a> : row.recommendation || '-' },
    // { id: 6, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? row.expectedOutcome.toFixed(2) : '-'}</div> }],
    {
      id: 6, name: 'expectedOutcome', label: 'SEARCH VOLUME', sortable: true, type: 'number', component: (row) => (
        <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div>
      )
    }
  ],

  // keyCol: 'ioNo',
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

//BLACKLIST

export const creativeBlacklistingTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'creativeName', label: 'CREATIVE NAME', sortable: true, type: 'string', component: (row) => <div>{row && row.creativeName ? row.creativeName : row.creativeId ? row.creativeId : '-'}</div> },
    { id: 6, name: 'creativeId', label: 'CREATIVE ID', sortable: true, type: 'number', component: (row) => <div>{row && row.creativeId ? row.creativeId : '-'}</div> },
    // { id: 7, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 7, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string', component: (row) => row && row.recommendation && isValidUrl(row.recommendation) ? <a href={row.recommendation} target="_blank" rel="noopener noreferrer" style={{ display: 'block', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.recommendation}>{row.recommendation}</a> : (row.recommendation || '-') },
    { id: 8, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const domainBlacklistingTable = {
  columns: [


    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'domain', label: 'DOMAIN', sortable: true, type: 'string' },
    { id: 6, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 7, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],  // keyCol: 'ioNo',
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const keyWordBlacklistingTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 7, name: 'keywordName', label: 'KEYWORD NAME', sortable: true, type: 'string', component: (row) => <div>{row && row.keywordName ? row.keywordName : '-'}</div> },
    { id: 8, name: 'keywordType', label: 'KEYWORD TYPE', sortable: true, type: 'string', component: (row) => <div>{row && row.keywordType ? row.keywordType : '-'}</div> },
    { id: 9, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 10, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const ageBlacklistingTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'age', label: 'AGE', sortable: true, type: 'string' },
    { id: 6, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 7, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const genderBlacklistingTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'gender', label: 'GENDER', sortable: true, type: 'string', component: (row) => <div className='text-capitalize'>{row && row.gender}</div> },
    { id: 6, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 7, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const placementBlacklistingTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'placement', label: 'PLACEMENT', sortable: true, type: 'string' },
    { id: 6, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 7, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const deviceBlacklistingTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'device', label: 'DEVICE NAME', sortable: true, type: 'string', component: (row) => <div>{row && row.device ? row.device : '-'}</div> },
    { id: 6, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 7, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const geoBlacklistingTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'geo', label: 'GEO', sortable: true, type: 'string', component: (row) => <div>{row && row.geo ? row.geo : '-'}</div> },
    // { id: 5, name: 'country', label: 'COUNTRY', sortable: true, type: 'string', component: (row) => <div>{row && row.country ? row.country : '-'}</div> },
    // { id: 6, name: 'state', label: 'STATE', sortable: true, type: 'string', component: (row) => <div>{row && row.state ? row.state : '-'}</div> },
    // { id: 7, name: 'city', label: 'CITY', sortable: true, type: 'string', component: (row) => <div>{row && row.city ? row.city : '-'}</div> },
    { id: 8, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 9, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};



//OPTIMIZER

export const budgetAllocationTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 6, name: 'oldBudget', label: 'OLD BUDGET', sortable: true, type: 'string' },
    { id: 7, name: 'allocatedBudget', label: 'ALLOCATED BUDGET', sortable: true, type: 'string' },
    { id: 8, name: 'currency', label: 'CURRENCY', sortable: true, type: 'string', component: (row) => <div>{row && row.currency ? row.currency : '-'}</div> },
    { id: 9, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },
    { id: 10, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },

  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const targetCpcTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 6, name: 'currentCpc', label: 'Current CPC', sortable: true, type: 'number' },
    { id: 7, name: 'targetCpc', label: 'Target CPC', sortable: true, type: 'number' },
    { id: 8, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 9, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const targetCpaTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'currentCPA', label: 'Current CPA', sortable: true, type: 'number' },
    { id: 6, name: 'targetCPA', label: 'Target CPA', sortable: true, type: 'number' },
    { id: 7, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 8, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const targetCpmTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 6, name: 'currentCPM', label: 'Current CPM', sortable: true, type: 'number' },
    { id: 7, name: 'targetCPM', label: 'Target CPM', sortable: true, type: 'number' },
    { id: 8, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 9, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const targetRoasTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 6, name: 'currentROAS', label: 'Current ROAS', sortable: true, type: 'number' },
    { id: 7, name: 'targetROAS', label: 'Target ROAS', sortable: true, type: 'number' },
    { id: 8, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 9, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

//BID CONTROL

export const ageBidControlTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'age', label: 'AGE', sortable: true, type: 'string', component: (row) => <div>{row && row.age ? row.age : '-'}</div> },
    { id: 6, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' },
    { id: 7, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 8, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const genderBidControlTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 6, name: 'gender', label: 'GENDER', sortable: true, type: 'string', component: (row) => <div>{row && row.gender ? row.gender : '-'}</div> },
    { id: 7, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' },
    { id: 8, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 9, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],

  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const audienceBidControlTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'audience', label: 'AUDIENCE', sortable: true, type: 'string' },
    { id: 6, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' },
    { id: 7, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 8, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],

  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const deviceBidControlTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 5, name: 'device', label: 'DEVICE NAME', sortable: true, type: 'string' },
    { id: 6, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' },
    { id: 7, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 8, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },


  ],

  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const geoBidControlTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'ADSET / STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string' },
    { id: 6, name: 'geo', label: 'GEO', sortable: true, type: 'string' },
    { id: 7, name: 'bidModification', label: 'BID MODIFICATION', sortable: true, type: 'string' },
    { id: 8, name: 'recommendation', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 9, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },


  ],

  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 10
  }
};

export const bidSubtypeBidControlTable = {
  columns: [
    { id: 1, name: 'date', label: 'DATE', sortable: true, type: 'string' },
    { id: 2, name: 'campaignInfo', label: 'CAMPAIGN INFO', resizable: true, sortable: true, type: 'string' },
    // { id: 3, name: 'adSetId', label: 'ADSET / STRATEGY ID', sortable: true, type: 'number' },
    {
      id: 3,
      name: 'platformSpecificId',
      label: 'STRATEGY ID',
      sortable: true,
      type: 'number',
      component: (row) => {
        const platformSpecificId = getPlatformSpecificId(row.platformName, row);
        return <div>{platformSpecificId.value || '-'}</div>;
      }
    },
    { id: 4, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string', },
    { id: 5, name: 'targetBid', label: 'TARGET BID', sortable: true, type: 'string' },
    { id: 6, name: 'subType', label: 'RECOMMENDATION', sortable: true, type: 'string' },
    { id: 7, name: 'expectedOutcome', label: 'EXPECTED OUTCOME(%)', sortable: true, type: 'number', component: (row) => <div>{row && row.expectedOutcome ? parseFloat(row.expectedOutcome).toFixed(2) : '-'}</div> },

  ],
  actions: [{
    type: 'accept',
    iconType: 'new',
    icon: 'ti ti-check color-success px-2 border-right',
    tooltip: 'Accept'
  },
  {
    type: 'reject',
    iconType: 'new',
    icon: 'ti ti-x color-danger px-2',
    tooltip: 'Reject'
  },
  {
    type: 'view',
    iconType: 'new',
    icon: 'ti ti-eye color-beki px-2  ',
    tooltip: 'View'
  },

  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 10
  }
};